export const betGamesData = {
  betgames1: {
    redirectUrl: "/casino/aggapbetgames-skyward-deluxe",
    imgUrl: "./images/betgames/skyward-deluxe.webp",
    name: "Skyward Deluxe",
  },
  betgames2: {
    redirectUrl: "/casino/aggapbetgames-lucky-7-u4981",
    imgUrl: "./images/betgames/lucky-7.webp",
    name: "Lucky 7",
  },
  betgames3: {
    redirectUrl: "/casino/aggapbetgames-live-roulette",
    imgUrl: "./images/betgames/liveroulette.webp",
    name: "Live Roulette",
  },
  betgames4: {
    redirectUrl: "/casino/aggapbetgames-gold-adventure",
    imgUrl: "./images/betgames/goldadventure.webp",
    name: "Gold Adventure",
  },
  betgames5: {
    redirectUrl: "/casino/aggapbetgames-bad-baboons-deluxe",
    imgUrl: "./images/betgames/badbaboonsdeluxe.webp",
    name: "Bad Baboons Deluxe",
  },
  betgames6: {
    redirectUrl: "/casino/aggapbetgames-instant-roulette",
    imgUrl: "./images/betgames/instantroulette.webp",
    name: "Instant Roulette",
  },
  betgames7: {
    redirectUrl: "/casino/aggapbetgames-lotus-wealth-wonders-deluxe",
    imgUrl: "./images/betgames/lotuswealthwonders-new.webp",
    name: " Lotus Wealth Wonders Deluxe",
  },
  betgames8: {
    redirectUrl: "/casino/aggapbetgames-forest-frenzy",
    imgUrl: "./images/betgames/forestfrenzy.webp",
    name: "Forest Frenzy",
  },
  betgames9: {
    redirectUrl: "/casino/aggapbetgames-crypt-of-giza-secrets-unveiled-deluxe",
    imgUrl: "./images/betgames/cryptofgizadeluxe.webp",
    name: "Crypt of Giza Secrets Unveiled Deluxe",
  },
  betgames10: {
    redirectUrl: "/casino/aggapbetgames-lucky-loki",
    imgUrl: "./images/betgames/luckyloki.webp",
    name: "Lucky Loki",
  },
  betgames11: {
    redirectUrl: "/casino/aggapbetgames-crypt-of-giza",
    imgUrl: "./images/betgames/crypofgiza.webp",
    name: "Crypt of Giza",
  },
  betgames12: {
    redirectUrl: "/casino/aggapbetgames-starzle",
    imgUrl: "./images/betgames/Starzle.webp",
    name: "Starzle",
  },
  betgames13: {
    redirectUrl: "/casino/aggapbetgames-crypt-of-giza-secrets-unveiled",
    imgUrl: "./images/betgames/cryptofgizasecrets.webp",
    name: "Crypt Of Giza - Secrets Unveiled",
  },
  betgames14: {
    redirectUrl: "/casino/aggapbetgames-lotus-wealth-wonders",
    imgUrl: "./images/betgames/lotuswealthwonders-new.webp",
    name: "Lotus Wealth Wonders",
  },
  betgames15: {
    redirectUrl: "/casino/aggapbetgames-candy-coins",
    imgUrl: "./images/betgames/candycoins.webp",
    name: "Candy Coins",
  },
  betgames16: {
    redirectUrl: "/casino/aggapbetgames-citrus-splash",
    imgUrl: "./images/betgames/citrussplash.webp",
    name: "Citrus Splash",
  },
  betgames17: {
    redirectUrl: "/casino/aggapbetgames-bad-baboons",
    imgUrl: "./images/betgames/bg_bad_baboons.webp",
    name: "Bad Baboons",
  },
  betgames18: {
    redirectUrl: "/casino/aggapbetgames-dragons-fate",
    imgUrl: "./images/betgames/dragonsfate.webp",
    name: "Dragon's Fate",
  },
  betgames19: {
    redirectUrl: "/casino/aggapbetgames-penguin-rush",
    imgUrl: "./images/betgames/penguinrush.webp",
    name: "Penguin Rush",
  },
  betgames20: {
    redirectUrl: "/casino/aggapbetgames-flash-roulette",
    imgUrl: "./images/betgames/flashroulette.webp",
    name: "Flash Roulette",
  },
  betgames21: {
    redirectUrl: "/casino/aggapbetgames-classic-roulette",
    imgUrl: "./images/betgames/ClassicRoulette.webp",
    name: "Classic Roulette",
  },
  betgames22: {
    redirectUrl: "/casino/aggapbetgames-instant-lucky-7",
    imgUrl: "./images/betgames/InstantLucky7.webp",
    name: "Instant Lucky 7",
  },
  betgames23: {
    redirectUrl: "/casino/aggapbetgames-skyward",
    imgUrl: "./images/betgames/skyward-new.webp",
    name: "Skyward",
  },
  betgames24: {
    redirectUrl: "/casino/aggapbetgames-football-grid",
    imgUrl: "./images/betgames/FootballGrid.webp",
    name: "Football Grid",
  },
  betgames25: {
    redirectUrl: "/casino/aggapbetgames-classic-wheel",
    imgUrl: "./images/betgames/ClassicWheel.webp",
    name: "Classic Wheel",
  },
  betgames26: {
    redirectUrl: "/casino/aggapbetgames-6-poker",
    imgUrl: "./images/betgames/6-Poker.webp",
    name: "6+ Poker",
  },
  betgames27: {
    redirectUrl: "/casino/aggapbetgames-speedy-7",
    imgUrl: "./images/betgames/speedy-7.webp",
    name: "Speedy 7",
  },
  betgames28: {
    redirectUrl: "/casino/aggapbetgames-dice-duel",
    imgUrl: "./images/betgames/DiceDuel.webp",
    name: "Dice Duel",
  },
  betgames29: {
    redirectUrl: "/casino/aggapbetgames-lucky-6",
    imgUrl: "./images/betgames/lucky-6.webp",
    name: "Lucky 6",
  },
  betgame30: {
    redirectUrl: "/casino/aggapbetgames-war-of-bets",
    imgUrl: "./images/betgames/WarofBets.webp",
    name: "War Of Bets",
  },
  betgame31: {
    redirectUrl: "/casino/aggapbetgames-wheel-of-fortune",
    imgUrl: "./images/betgames/WheelofFortune.webp",
    name: "Wheel Of Fortune",
  },
  betgame32: {
    redirectUrl: "/casino/aggapbetgames-bet-on-baccarat",
    imgUrl: "./images/betgames/BetonBaccarat.webp",
    name: "Bet On Baccarat",
  },
  betgame33: {
    redirectUrl: "/casino/aggapbetgames-bet-on-poker",
    imgUrl: "./images/betgames/bet_on_poker.webp",
    name: "Bet On Poker",
  },
  betgame34: {
    redirectUrl: "/casino/aggapbetgames-lucky-5",
    imgUrl: "./images/betgames/lucky-5.webp",
    name: "Lucky 5",
  },
};
